import React, { useEffect, useState } from 'react';
import { Button, Box, Typography, Alert } from '@mui/material';
import { initializeNotifications } from '../services/notificationService';
import axios from 'axios';

export const NotificationTest = () => {
  const [permission, setPermission] = useState<NotificationPermission>('default');
  const [token, setToken] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Check current notification permission
    setPermission(Notification.permission);
  }, []);

  const handleEnableNotifications = async () => {
    try {
      setError(null);
      const deviceId = await initializeNotifications();
      setToken(deviceId);
      setPermission(Notification.permission);
    } catch (err) {
      console.error('Error enabling notifications:', err);
      setError('Failed to enable notifications. Please try again.');
    }
  };

  const handleTestNotification = async () => {
    try {
      setError(null);
      await axios.post('/api/notifications/test');
    } catch (err) {
      
      setError('Failed to send test notification. Please try again.');
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Notification Settings
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Box sx={{ mb: 2 }}>
        <Typography variant="body1" gutterBottom>
          Current Permission Status: <strong>{permission}</strong>
        </Typography>
        {token && (
          <Typography variant="body2" color="text.secondary">
            FCM Token registered successfully
          </Typography>
        )}
      </Box>

      <Box sx={{ '& > button': { mr: 2 } }}>
        {permission !== 'granted' && (
          <Button
            variant="contained"
            color="primary"
            onClick={handleEnableNotifications}
          >
            Enable Notifications
          </Button>
        )}
        {permission === 'granted' && (
          <Button
            variant="contained"
            color="secondary"
            onClick={handleTestNotification}
          >
            Send Test Notification
          </Button>
        )}
      </Box>
    </Box>
  );
};
